var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66663C14.6025 1.66663 18.3333 5.39746 18.3333 9.99996C18.3333 14.6025 14.6025 18.3333 9.99996 18.3333C5.39746 18.3333 1.66663 14.6025 1.66663 9.99996C1.66663 5.39746 5.39746 1.66663 9.99996 1.66663ZM9.99163 8.33329H9.16663C8.95423 8.33353 8.74993 8.41486 8.59549 8.56067C8.44104 8.70647 8.3481 8.90575 8.33565 9.11779C8.3232 9.32982 8.39219 9.53861 8.52851 9.70149C8.66484 9.86436 8.85821 9.96904 9.06913 9.99413L9.16663 9.99996V14.1583C9.16663 14.5916 9.49496 14.95 9.91663 14.995L10.0083 15H10.4166C10.5919 15 10.7627 14.9447 10.9047 14.8421C11.0468 14.7394 11.1529 14.5946 11.2079 14.4282C11.2629 14.2618 11.264 14.0823 11.2111 13.9152C11.1582 13.7481 11.054 13.6019 10.9133 13.4975L10.8333 13.445V9.17496C10.8333 8.74163 10.505 8.38329 10.0833 8.33829L9.99163 8.33329ZM9.99996 5.83329C9.77894 5.83329 9.56698 5.92109 9.4107 6.07737C9.25442 6.23365 9.16663 6.44561 9.16663 6.66663C9.16663 6.88764 9.25442 7.0996 9.4107 7.25588C9.56698 7.41216 9.77894 7.49996 9.99996 7.49996C10.221 7.49996 10.4329 7.41216 10.5892 7.25588C10.7455 7.0996 10.8333 6.88764 10.8333 6.66663C10.8333 6.44561 10.7455 6.23365 10.5892 6.07737C10.4329 5.92109 10.221 5.83329 9.99996 5.83329Z",
    fill: "#009EF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningInfo);
export default __webpack_public_path__ + "static/media/warning-info.df4133e45bc657a52e9d080c49d34364.svg";
export { ForwardRef as ReactComponent };